// extracted by mini-css-extract-plugin
export var caret = "lcBreadcrumbs-module--caret--95bef";
export var container = "lcBreadcrumbs-module--container--e88cf";
export var link = "lcBreadcrumbs-module--link--b3af9";
export var linkContainer = "lcBreadcrumbs-module--linkContainer--9078c";